<template>
	<div>
		<transition name="modal">
			<div class="modal-mask">
				<div class="modal-wrapper" @click="$emit('showModalFalse')">
					<div class="row">
						<div class="col-xs-2 col-sm-2 col-md-2 col-lg-3"></div>
						<div class="col-xs-8 col-sm-8 col-md-8 col-lg-6">
							<div class="modal-container" @click.stop>
								<div class="modal-body">
									<b-form  @submit.prevent="''">
                                        <p style="color:red">{{fileError}}</p>
                                        <h4 class="text-center">{{variable}}</h4>
                                        <!-- <b-form-row>
                                            <b-form-group class="col-12" label="Kondisi Barang" >
                                                <Multiselect
                                                    :options="[ 'Ada, Kondisi Oke', 'Ada, Rusak' , 'Tidak Ada']"
                                                    v-model="condition"
                                                    :close-on-select="true"
                                                    :allow-empty="false"
                                                >
                                                </Multiselect>
                                            </b-form-group>
                                        </b-form-row> -->
                                        <!-- <b-form-row>
                                            <b-form-group label="Deskripsi" class=" col-12">
                                                <input type="text" class="form-control" v-model="desc">
                                            </b-form-group>
                                            <br>
                                            <div class="row w-100 mb-3 pl-2">
                                                <div class="col-4 col-md-2 mt-1" v-for="text in commonText" :key="text">
                                                    <div class=" pt-1 pb-1 pl-2 pr-2 w-100 rounded shadow text-center" :class="{'bg-grey' : selectedText != text , 'bg-light-grey' : selectedText == text}" @click="setText(text)">
                                                        {{text}}
                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </b-form-row> -->
                                        

										<b-form-row v-if="(variable.includes('VALUABLES') && condition != 'Tidak Ada') || (!variable.includes('VALUABLES') && condition != 'Ada, Kondisi Oke')">
											<b-form-group :label="`Unggah Gambar ` " class="col-12">
												
												<input :disabled="file.length >= 5" type="file" name="myImage" accept="image/*"  class="form-control" @change="validateSize" multiple/>
                                                <br>
                                                <p>Maksimal 5 Gambar</p>
											</b-form-group>
										</b-form-row>
                                        
										<b-form-row v-if="file.length > 0 && url.length > 0">
                                            <template class="w-100" >
                                                <div v-for="(url, index) in url" :key="url" class="text-center row">
                                                    <b-form-group class="col-12 col-md text-center"  style="width:225px">
                                                        <img :src="url" class="img-fluid" style="height:15vh;"/>
                                                        <br>
                                                       <button type="button" @click="deleteImage(index)" class="btn btn-warning w-50 mt-2">Hapus</button>
                                                    </b-form-group>
                                                     
                                                    
                                                </div>
                                            </template>
										</b-form-row>
										<b-form-row >
                                            <b-form-group class="col-6 text-center">
												<button type="button" @click="$emit('showModalFalse')" class="btn btn-danger w-50">Batal</button>
											</b-form-group>
											<b-form-group class="col-6 text-center" v-if="file && url">
												<button type="button" @click="uploadImage" class="btn btn-primary w-50">Unggah Gambar</button>
											</b-form-group>
                                           
										</b-form-row>
									</b-form>
								</div>
							</div>
						</div>
						<div class="col-xs-2 col-sm-2 col-md-2 col-lg-3"></div>
					</div>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import env from '@/env'
export default {
    components : {
        Multiselect
    },
	props: ['variable'],
	data () {
		return {
			file: [],
			fileError: '',
            url: [],
            desc : '',
            condition : null,
            selectedText : '',
            commonText : ['Boncel' , 'Rusak' , 'Pecah' , 'Hancur' , 'Bagus' , 'Ada' , 'Baret', 'Penyok']
		}
	},
	methods: {
        setText(text) {
            if(this.selectedText == text){
                this.selectedText = ''
                this.desc = ''
            }   
            else {
                this.selectedText = text
                this.desc = text
            }
        },
		validateSize : function(data){
			
            var file = data.target.files;

            if (file.length > 5) {
                this.fileError = "Maximum Gambar Diunduh 5 Gambar"
                return false
            }
            for(var i = 0 ; i < file.length ; i ++) {
                var size  = file[i].size / 1024 / 1024;

                if(size > 20)
                {
                    this.fileError = "Limit Size Gambar 8 MB";
                    return false;
                }

                this.fileError = "";
                let blobURL = URL.createObjectURL(file[i])
                let vm = this;

                if(size > 1) {
                    let img = new Image();
                    img.src = blobURL;
                    img.onload = function (ev) {
                        let canvas = document.createElement('canvas');
                        canvas.width = img.width;
                        canvas.height = img.height;

                        let ctx = canvas.getContext('2d');
                        ctx.drawImage(img, 0, 0, img.width, img.height);

                        let base64 = canvas.toDataURL('image/jpeg' , 0.6)


                        let modifiedFile = vm.dataURLtoFile(base64 , 'image.jpg')
                        vm.file.push(modifiedFile)
                        vm.url.push(URL.createObjectURL(modifiedFile))

                    };
                }
                else {
                    this.file.push(file[i]) ;
                    this.url.push(blobURL);
                }
                
            }

            return true;
            
		},
		async uploadImage () {
            let image = null
            // if ((this.variable.includes('VALUABLES') && this.condition != 'Tidak Ada') || (!this.variable.includes('VALUABLES') && this.condition != 'Ada, Kondisi Oke') && this.file.length <= 0) {
            //     this.fileError = 'Gambar Wajib Di Unggah!'
            //     return;
            // }
            // else {
            //     image = await this.uploadAllImage()
            // }

            // image = 
            

            // if (!this.condition) {
            //     this.fileError = 'Kondisi Barang Wajib Di isi!'
            //     return
            // }

            

            

            // let data = {
            //     image : image  ? image : null, 
            //     desc : this.desc == '' ? this.condition : this.desc,
            //     condition : this.condition
            // }
            
            this.$emit('uploadImage' , this.variable , await this.uploadAllImage())
            
        },
        async uploadAllImage() {
            let image = []
            let url = env.urlStart + "/api/v1/workorder/image"
            for(var i = 0 ; i < this.file.length ;  i++) {
                let formData = new FormData()

                formData.append('work_order' , this.file[i])
                
                let response = await this.$http.post(url , formData , {headers : {"Content-Type":'multipart/form-data'}})
                image.push(response.data.data.filename)
            }
            
            return image
            
        },
        deleteImage (index) {
            this.url.splice(index, 1)
            this.file.splice(index , 1)
        }
	}
}
</script>

<style>
.modal-mask {
        position: fixed;
        z-index: 1050;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 100%;
        margin: 0px auto;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 10px 0;
    }

    .modal-default-button {
        float: right;
    }

    /*
    * The following styles are auto-applied to elements with
    * transition="modal" when their visibility is toggled
    * by Vue.js.
    *
    * You can easily play with the modal transition by editing
    * these styles.
    */

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

    /* MODAL STARTS */
    .modal-body{
        margin:0
    }

    .modal-body .moduleLine{
        margin-bottom: 0vh;
    }

    .modal-body .moduleLine a{
        text-decoration: none;
    }

    .modal-body .moduleLine .moduleBox:hover{
        background-color: #E0E0E0;
        transition: background-color 0.7s ease;
        color: #212121;
        transition: color 0.7s ease;
    }

    .modal-body .moduleLine .moduleBox{
        border:1px solid #BDBDBD;
        border-radius: 20px;
        padding: 20px 0;
        color:black;
        margin-bottom: 3vh;
    }

    .modal-body .moduleLine .moduleBox i{
        font-size:5vh;
    }

    h3.modalHeadline{
        margin:0 0 20px 0
    }
    /* MODAL ENDS */

    .modalContent tr th{
      text-align:right;
    }

    .modalContent tr .middleDivider{
      width: 50px;
      text-align: center;
    }
</style>